import { gql } from '@apollo/client';

const TASK_UPDATE = gql`
  mutation TaskUpdate($input: TaskUpdateInput!) {
    taskUpdate(input: $input) {
      errors {
        error
        message
      }
      task {
        __typename
        id
        title
        details
        instructions
        photoCaptureRequired
      }
    }
  }
`;

export default TASK_UPDATE;
